import React, { createContext, useContext, useState } from 'react';

const AudienceContext = createContext(null);

export function AudienceProvider({ children }) {
  const [audience, setAudience] = useState('adult'); // 'adult' or 'pediatric'

  const toggleAudience = () => {
    setAudience(prev => prev === 'adult' ? 'pediatric' : 'adult');
  };

  const value = {
    audience,
    setAudience,
    toggleAudience,
    isAdult: audience === 'adult',
    isPediatric: audience === 'pediatric'
  };

  return (
    <AudienceContext.Provider value={value}>
      {children}
    </AudienceContext.Provider>
  );
}

export function useAudience() {
  const context = useContext(AudienceContext);
  if (!context) {
    throw new Error('useAudience must be used within AudienceProvider');
  }
  return context;
}
